
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as index3pJhvIijmjT17mM_pRJ4zaLmrp5m1aZaMmNQgbeh4BcMeta } from "/opt/buildhome/repo/pages/staff/index.vue?macro=true";
import { default as createe1FSkzFOwcM3fRJMGj6sv76V0Mc__bTbJxodYwmJp98Meta } from "/opt/buildhome/repo/pages/staff/create.vue?macro=true";
import { default as _91userId_93VMMCLCDQCtmCPhUGvZbWj_kHxJ_53naZ0djBpCL0qbMMeta } from "/opt/buildhome/repo/pages/staff/[userId].vue?macro=true";
import { default as staffWcbn3gEDYAfumZsukoEcIrxjMbpe4QT8K0efWuCUIpgMeta } from "/opt/buildhome/repo/pages/staff.vue?macro=true";
import { default as indexDsyvSvW4zxBWyMdY4V5n3cu_45XWfmJTzSlx2swtjH8tUMeta } from "/opt/buildhome/repo/pages/tasks/index.vue?macro=true";
import { default as warehousing_images_TePSsNLgkxSAZ7yiO4YEltciu6gH1UrFjd1pyCoUY0Meta } from "/opt/buildhome/repo/pages/tasks/[taskId]/warehousing_images.vue?macro=true";
import { default as _91arrangementTaskId_930a35Wfm6vx_jkQfRNYfSJEDsIWpZe3K8XvDdWwfoNEEMeta } from "/opt/buildhome/repo/pages/tasks/[taskId]/vehicles/[arrangementTaskId].vue?macro=true";
import { default as _91taskId_93S532SMo_4556MC7PsBg_45dHy4ZfuETIfS65XyMqBONvYOYMeta } from "/opt/buildhome/repo/pages/tasks/[taskId].vue?macro=true";
import { default as tasksyXXfcks37_JN5S9AUt3Es6IPUY2yl0rL5axRcO2N_45owMeta } from "/opt/buildhome/repo/pages/tasks.vue?macro=true";
import { default as createNQmRHk8XaxBwOiUGWmWDSry_45odda7cx0ByKm_45w0ZAjUMeta } from "/opt/buildhome/repo/pages/users/create.vue?macro=true";
import { default as _91userId_93ycZli5tMUmlQibMYKJfiblMR_gA2n862gJUHxB1MB8kMeta } from "/opt/buildhome/repo/pages/users/[userId].vue?macro=true";
import { default as usersDdKPYX7w1ohR5mdXAQEOOek61BW6bWXppqUQM2l77ncMeta } from "/opt/buildhome/repo/pages/users.vue?macro=true";
import { default as indexrMM2pb1xNKpc9dn0El6FwInZ7F8HIHFEh6lVMb_KLsUMeta } from "/opt/buildhome/repo/pages/orders/index.vue?macro=true";
import { default as create7EoN_45tIohijNK2jcTBGO1ZwqThXhUcnhxYV754IERRIMeta } from "/opt/buildhome/repo/pages/orders/create.vue?macro=true";
import { default as invoiceCdBoIMLhl03_45H9va_45_45Oes5w5GCvDMuceJ7wsC6lc0CUMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/invoice.vue?macro=true";
import { default as estimateBr6j4D2oxjlX7M9c2JY49OMcaHJbQ665v5ZR0AhpihEMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/estimate.vue?macro=true";
import { default as procurement_expensehCJcoA944fsQpctGofObsohAq3MweBPwJd4p6c7ziYQMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/procurement_expense.vue?macro=true";
import { default as _91orderId_93ktRYyrc9koV_45e96RkiUlq5Ckq1gi2pD2q0jNeka3TW4Meta } from "/opt/buildhome/repo/pages/orders/[orderId].vue?macro=true";
import { default as ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta } from "/opt/buildhome/repo/pages/orders.vue?macro=true";
import { default as createcgJog7ZV3_4500t5J8XAWml8F42A9io_455DkfS69camYCEMeta } from "/opt/buildhome/repo/pages/clients/create.vue?macro=true";
import { default as poas5vOdKNzDlEy56Faba3F3Q3GCHKBcW7HOgjt2It6OjA8Meta } from "/opt/buildhome/repo/pages/clients/[orgId]/poas.vue?macro=true";
import { default as usersC5XbnG07fB4XKrR_KULWp9E48Fpse5i2T3pIloY8RKsMeta } from "/opt/buildhome/repo/pages/clients/[orgId]/users.vue?macro=true";
import { default as _91orgId_93YZlw0ESua84P8FyPHrILY797TVPD_45lmUMygBwdsPFmIMeta } from "/opt/buildhome/repo/pages/clients/[orgId].vue?macro=true";
import { default as clientsvmHvLJMtKB7Dt7LRW8viNmKAZu_v4vbpoi2GfaAt2QgMeta } from "/opt/buildhome/repo/pages/clients.vue?macro=true";
import { default as _91taskId_93H8RtPeMWQd1a2FinuEqrxX7r_OH1b1NUDhRylxPAtAwMeta } from "/opt/buildhome/repo/pages/customs/[taskId].vue?macro=true";
import { default as customsPfzhXMhEB_jyHWYph1HWJ0_69AJt0vptqyv0_45pqrPNMMeta } from "/opt/buildhome/repo/pages/customs.vue?macro=true";
import { default as vesselsjixYcwGPS6GRMvXimrsOvCcEFEcu36kYtMZ28qlNfXgMeta } from "/opt/buildhome/repo/pages/vessels.vue?macro=true";
import { default as createFrkeN0EeNJbHU6ZBnf6xTikjjwds86NFr40qvAUn2qwMeta } from "/opt/buildhome/repo/pages/agencies/create.vue?macro=true";
import { default as usersuft1LmVSqAbExg2tYDR_45IXSh47ad3BOUcyRr9BVeeZgMeta } from "/opt/buildhome/repo/pages/agencies/[orgId]/users.vue?macro=true";
import { default as _91orgId_93_45tYNJTnq8zDzGrZ7kdqkEGH_45P_2udMRMPMe4qGDcJ_AMeta } from "/opt/buildhome/repo/pages/agencies/[orgId].vue?macro=true";
import { default as agenciesQJtPwNDE3nnPCkjguw0E6KzGu0BE2ECbKrIcKkdnbWEMeta } from "/opt/buildhome/repo/pages/agencies.vue?macro=true";
import { default as createhEnK5dbwILaAHTOSVNBRxUpUIZ5DziB9hm9uizfgNQkMeta } from "/opt/buildhome/repo/pages/partners/create.vue?macro=true";
import { default as _91orgId_930VCww3exR_mAgdFj_459xYfjL0aQkUw3roQD6RruyeN9EMeta } from "/opt/buildhome/repo/pages/partners/[orgId].vue?macro=true";
import { default as partnersao1kliWZBFRJeyJKvwLj2JSuVY147FKb4C_45ISyvc_3cMeta } from "/opt/buildhome/repo/pages/partners.vue?macro=true";
import { default as loginToPgpW8_tXmskc2BbXueNhl3DgZ0QNEnbjd_45I2g34csMeta } from "/opt/buildhome/repo/pages/admin/login.vue?macro=true";
import { default as createKxgFQJ_45zUrSAm4pV8Py8twjc2EXlrAR6NxaGplX4148Meta } from "/opt/buildhome/repo/pages/organizations/create.vue?macro=true";
import { default as _91orgId_93JpcmFjSt2nqyqX_45EgHMCsBhcsmc5W1Tr7X1Awxx6WWsMeta } from "/opt/buildhome/repo/pages/organizations/[orgId].vue?macro=true";
import { default as organizations0QFIfBxNfcH_45VYwlW8vZ_45L8r7Rtz4UFovEZpjZZcCl0Meta } from "/opt/buildhome/repo/pages/organizations.vue?macro=true";
import { default as quickestimateOvZrcIBvQtYjmdQKsSgoQt9AO1Bgn4S5XrpaK3QhV9EMeta } from "/opt/buildhome/repo/pages/quickestimate.vue?macro=true";
import { default as estimator_45tokenF8t6ddq_45E_45pE0PRjlpSRCp57vfY31lcn__PPTSH58BMMeta } from "/opt/buildhome/repo/pages/estimator-token.vue?macro=true";
import { default as _91invoiceId_93d03gfMQmzdRppeauAbuOoWIJwQGVtBTaeEdMGDdjnsIMeta } from "/opt/buildhome/repo/pages/issued_invoices/[invoiceId].vue?macro=true";
import { default as issued_invoicesOT1QpYxQ_nMTx7j2NXRbZKIT822t5_45QNiwbf53hceA0Meta } from "/opt/buildhome/repo/pages/issued_invoices.vue?macro=true";
import { default as _91id_93YAn3tMG_urKpuayYcgPHgbun5UTJTQ1IQDSxfNzDN0YMeta } from "/opt/buildhome/repo/pages/approval_requests/[id].vue?macro=true";
import { default as approval_requestsuUmdlI_TvSJoLaot2BvImfEDnXaV1c3aHtlve7hMwFkMeta } from "/opt/buildhome/repo/pages/approval_requests.vue?macro=true";
import { default as _91invoiceId_93N_GN_45zHfSwaKGc_45TOyaNfSN3BDRSarDAdUD4OcGaNDYMeta } from "/opt/buildhome/repo/pages/approved_invoices/[invoiceId].vue?macro=true";
import { default as approved_invoicesWbiUTTr8LSNi0SWH136PWS_45UP7sl_454vw7Q5h1L5lUwoMeta } from "/opt/buildhome/repo/pages/approved_invoices.vue?macro=true";
import { default as createAZe0mk5L3TQsyJJeD36n4J4_45nVRX0KuF_45A93Ah5YLsMMeta } from "/opt/buildhome/repo/pages/bonded_warehouses/create.vue?macro=true";
import { default as _91bondedWarehouseId_93T6pJ9FP1e9oaGJ4jMgYCg4o8_TW6r7Eqb3tipQO6YkIMeta } from "/opt/buildhome/repo/pages/bonded_warehouses/[bondedWarehouseId].vue?macro=true";
import { default as bonded_warehousesRMPas7RsGWMGNFrBbNqcfQOZe1p6FoVimLkqEhme0_0Meta } from "/opt/buildhome/repo/pages/bonded_warehouses.vue?macro=true";
import { default as _91orderId_93_qO5dKNFXNsdCp1a51TKnbgZmhjkKM7S6Gxf9qe1VWMMeta } from "/opt/buildhome/repo/pages/billing_and_payments/[orderId].vue?macro=true";
import { default as billing_and_paymentsGzsHUDJvAi8PwDXNdafcX960mpl6mhBfN0Zo33Jr9bkMeta } from "/opt/buildhome/repo/pages/billing_and_payments.vue?macro=true";
import { default as importOzI6FqveXyWaFdeLJ5f0Gadqr67IdM1DCEJazJ0aRygMeta } from "/opt/buildhome/repo/pages/procurement_expenses/import.vue?macro=true";
export default [
  {
    name: "index___ja___default",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___zh-cn",
    path: "/zh-cn",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login___ja___default",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___zh-cn",
    path: "/zh-cn/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: staffWcbn3gEDYAfumZsukoEcIrxjMbpe4QT8K0efWuCUIpgMeta?.name,
    path: "/staff",
    component: () => import("/opt/buildhome/repo/pages/staff.vue"),
    children: [
  {
    name: "staff___ja___default",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/staff/index.vue")
  },
  {
    name: "staff-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/staff/create.vue")
  },
  {
    name: "staff-userId___ja___default",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/staff/[userId].vue")
  }
]
  },
  {
    name: staffWcbn3gEDYAfumZsukoEcIrxjMbpe4QT8K0efWuCUIpgMeta?.name,
    path: "/ja/staff",
    component: () => import("/opt/buildhome/repo/pages/staff.vue"),
    children: [
  {
    name: "staff___ja",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/staff/index.vue")
  },
  {
    name: "staff-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/staff/create.vue")
  },
  {
    name: "staff-userId___ja",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/staff/[userId].vue")
  }
]
  },
  {
    name: staffWcbn3gEDYAfumZsukoEcIrxjMbpe4QT8K0efWuCUIpgMeta?.name,
    path: "/en/staff",
    component: () => import("/opt/buildhome/repo/pages/staff.vue"),
    children: [
  {
    name: "staff___en",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/staff/index.vue")
  },
  {
    name: "staff-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/staff/create.vue")
  },
  {
    name: "staff-userId___en",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/staff/[userId].vue")
  }
]
  },
  {
    name: staffWcbn3gEDYAfumZsukoEcIrxjMbpe4QT8K0efWuCUIpgMeta?.name,
    path: "/zh-cn/staff",
    component: () => import("/opt/buildhome/repo/pages/staff.vue"),
    children: [
  {
    name: "staff___zh-cn",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/staff/index.vue")
  },
  {
    name: "staff-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/staff/create.vue")
  },
  {
    name: "staff-userId___zh-cn",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/staff/[userId].vue")
  }
]
  },
  {
    name: tasksyXXfcks37_JN5S9AUt3Es6IPUY2yl0rL5axRcO2N_45owMeta?.name,
    path: "/tasks",
    component: () => import("/opt/buildhome/repo/pages/tasks.vue"),
    children: [
  {
    name: "tasks___ja___default",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/tasks/index.vue")
  },
  {
    name: "tasks-taskId___ja___default",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId].vue"),
    children: [
  {
    name: "tasks-taskId-warehousing_images___ja___default",
    path: "warehousing_images",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/warehousing_images.vue")
  },
  {
    name: "tasks-taskId-vehicles-arrangementTaskId___ja___default",
    path: "vehicles/:arrangementTaskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/vehicles/[arrangementTaskId].vue")
  }
]
  }
]
  },
  {
    name: tasksyXXfcks37_JN5S9AUt3Es6IPUY2yl0rL5axRcO2N_45owMeta?.name,
    path: "/ja/tasks",
    component: () => import("/opt/buildhome/repo/pages/tasks.vue"),
    children: [
  {
    name: "tasks___ja",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/tasks/index.vue")
  },
  {
    name: "tasks-taskId___ja",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId].vue"),
    children: [
  {
    name: "tasks-taskId-warehousing_images___ja",
    path: "warehousing_images",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/warehousing_images.vue")
  },
  {
    name: "tasks-taskId-vehicles-arrangementTaskId___ja",
    path: "vehicles/:arrangementTaskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/vehicles/[arrangementTaskId].vue")
  }
]
  }
]
  },
  {
    name: tasksyXXfcks37_JN5S9AUt3Es6IPUY2yl0rL5axRcO2N_45owMeta?.name,
    path: "/en/tasks",
    component: () => import("/opt/buildhome/repo/pages/tasks.vue"),
    children: [
  {
    name: "tasks___en",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/tasks/index.vue")
  },
  {
    name: "tasks-taskId___en",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId].vue"),
    children: [
  {
    name: "tasks-taskId-warehousing_images___en",
    path: "warehousing_images",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/warehousing_images.vue")
  },
  {
    name: "tasks-taskId-vehicles-arrangementTaskId___en",
    path: "vehicles/:arrangementTaskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/vehicles/[arrangementTaskId].vue")
  }
]
  }
]
  },
  {
    name: tasksyXXfcks37_JN5S9AUt3Es6IPUY2yl0rL5axRcO2N_45owMeta?.name,
    path: "/zh-cn/tasks",
    component: () => import("/opt/buildhome/repo/pages/tasks.vue"),
    children: [
  {
    name: "tasks___zh-cn",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/tasks/index.vue")
  },
  {
    name: "tasks-taskId___zh-cn",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId].vue"),
    children: [
  {
    name: "tasks-taskId-warehousing_images___zh-cn",
    path: "warehousing_images",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/warehousing_images.vue")
  },
  {
    name: "tasks-taskId-vehicles-arrangementTaskId___zh-cn",
    path: "vehicles/:arrangementTaskId()",
    component: () => import("/opt/buildhome/repo/pages/tasks/[taskId]/vehicles/[arrangementTaskId].vue")
  }
]
  }
]
  },
  {
    name: "users___ja___default",
    path: "/users",
    component: () => import("/opt/buildhome/repo/pages/users.vue"),
    children: [
  {
    name: "users-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/users/create.vue")
  },
  {
    name: "users-userId___ja___default",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/users/[userId].vue")
  }
]
  },
  {
    name: "users___ja",
    path: "/ja/users",
    component: () => import("/opt/buildhome/repo/pages/users.vue"),
    children: [
  {
    name: "users-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/users/create.vue")
  },
  {
    name: "users-userId___ja",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/users/[userId].vue")
  }
]
  },
  {
    name: "users___en",
    path: "/en/users",
    component: () => import("/opt/buildhome/repo/pages/users.vue"),
    children: [
  {
    name: "users-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/users/create.vue")
  },
  {
    name: "users-userId___en",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/users/[userId].vue")
  }
]
  },
  {
    name: "users___zh-cn",
    path: "/zh-cn/users",
    component: () => import("/opt/buildhome/repo/pages/users.vue"),
    children: [
  {
    name: "users-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/users/create.vue")
  },
  {
    name: "users-userId___zh-cn",
    path: ":userId()",
    component: () => import("/opt/buildhome/repo/pages/users/[userId].vue")
  }
]
  },
  {
    name: ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta?.name,
    path: "/orders",
    component: () => import("/opt/buildhome/repo/pages/orders.vue"),
    children: [
  {
    name: "orders___ja___default",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/orders/index.vue")
  },
  {
    name: "orders-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/orders/create.vue")
  },
  {
    name: "orders-orderId___ja___default",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId].vue"),
    children: [
  {
    name: "orders-orderId-invoice___ja___default",
    path: "invoice",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/invoice.vue")
  },
  {
    name: "orders-orderId-estimate___ja___default",
    path: "estimate",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/estimate.vue")
  },
  {
    name: "orders-orderId-procurement_expense___ja___default",
    path: "procurement_expense",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/procurement_expense.vue")
  }
]
  }
]
  },
  {
    name: ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta?.name,
    path: "/ja/orders",
    component: () => import("/opt/buildhome/repo/pages/orders.vue"),
    children: [
  {
    name: "orders___ja",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/orders/index.vue")
  },
  {
    name: "orders-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/orders/create.vue")
  },
  {
    name: "orders-orderId___ja",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId].vue"),
    children: [
  {
    name: "orders-orderId-invoice___ja",
    path: "invoice",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/invoice.vue")
  },
  {
    name: "orders-orderId-estimate___ja",
    path: "estimate",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/estimate.vue")
  },
  {
    name: "orders-orderId-procurement_expense___ja",
    path: "procurement_expense",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/procurement_expense.vue")
  }
]
  }
]
  },
  {
    name: ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta?.name,
    path: "/en/orders",
    component: () => import("/opt/buildhome/repo/pages/orders.vue"),
    children: [
  {
    name: "orders___en",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/orders/index.vue")
  },
  {
    name: "orders-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/orders/create.vue")
  },
  {
    name: "orders-orderId___en",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId].vue"),
    children: [
  {
    name: "orders-orderId-invoice___en",
    path: "invoice",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/invoice.vue")
  },
  {
    name: "orders-orderId-estimate___en",
    path: "estimate",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/estimate.vue")
  },
  {
    name: "orders-orderId-procurement_expense___en",
    path: "procurement_expense",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/procurement_expense.vue")
  }
]
  }
]
  },
  {
    name: ordersbykzvWgceilKkMpFXAx0hhlDa7s_45ZHIPIATLTDuLIt8Meta?.name,
    path: "/zh-cn/orders",
    component: () => import("/opt/buildhome/repo/pages/orders.vue"),
    children: [
  {
    name: "orders___zh-cn",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/orders/index.vue")
  },
  {
    name: "orders-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/orders/create.vue")
  },
  {
    name: "orders-orderId___zh-cn",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId].vue"),
    children: [
  {
    name: "orders-orderId-invoice___zh-cn",
    path: "invoice",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/invoice.vue")
  },
  {
    name: "orders-orderId-estimate___zh-cn",
    path: "estimate",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/estimate.vue")
  },
  {
    name: "orders-orderId-procurement_expense___zh-cn",
    path: "procurement_expense",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/procurement_expense.vue")
  }
]
  }
]
  },
  {
    name: "clients___ja___default",
    path: "/clients",
    component: () => import("/opt/buildhome/repo/pages/clients.vue"),
    children: [
  {
    name: "clients-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/clients/create.vue")
  },
  {
    name: "clients-orgId___ja___default",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId].vue"),
    children: [
  {
    name: "clients-orgId-poas___ja___default",
    path: "poas",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/poas.vue")
  },
  {
    name: "clients-orgId-users___ja___default",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "clients___ja",
    path: "/ja/clients",
    component: () => import("/opt/buildhome/repo/pages/clients.vue"),
    children: [
  {
    name: "clients-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/clients/create.vue")
  },
  {
    name: "clients-orgId___ja",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId].vue"),
    children: [
  {
    name: "clients-orgId-poas___ja",
    path: "poas",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/poas.vue")
  },
  {
    name: "clients-orgId-users___ja",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "clients___en",
    path: "/en/clients",
    component: () => import("/opt/buildhome/repo/pages/clients.vue"),
    children: [
  {
    name: "clients-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/clients/create.vue")
  },
  {
    name: "clients-orgId___en",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId].vue"),
    children: [
  {
    name: "clients-orgId-poas___en",
    path: "poas",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/poas.vue")
  },
  {
    name: "clients-orgId-users___en",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "clients___zh-cn",
    path: "/zh-cn/clients",
    component: () => import("/opt/buildhome/repo/pages/clients.vue"),
    children: [
  {
    name: "clients-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/clients/create.vue")
  },
  {
    name: "clients-orgId___zh-cn",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId].vue"),
    children: [
  {
    name: "clients-orgId-poas___zh-cn",
    path: "poas",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/poas.vue")
  },
  {
    name: "clients-orgId-users___zh-cn",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/clients/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "customs___ja___default",
    path: "/customs",
    component: () => import("/opt/buildhome/repo/pages/customs.vue"),
    children: [
  {
    name: "customs-taskId___ja___default",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/customs/[taskId].vue")
  }
]
  },
  {
    name: "customs___ja",
    path: "/ja/customs",
    component: () => import("/opt/buildhome/repo/pages/customs.vue"),
    children: [
  {
    name: "customs-taskId___ja",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/customs/[taskId].vue")
  }
]
  },
  {
    name: "customs___en",
    path: "/en/customs",
    component: () => import("/opt/buildhome/repo/pages/customs.vue"),
    children: [
  {
    name: "customs-taskId___en",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/customs/[taskId].vue")
  }
]
  },
  {
    name: "customs___zh-cn",
    path: "/zh-cn/customs",
    component: () => import("/opt/buildhome/repo/pages/customs.vue"),
    children: [
  {
    name: "customs-taskId___zh-cn",
    path: ":taskId()",
    component: () => import("/opt/buildhome/repo/pages/customs/[taskId].vue")
  }
]
  },
  {
    name: "vessels___ja___default",
    path: "/vessels",
    component: () => import("/opt/buildhome/repo/pages/vessels.vue")
  },
  {
    name: "vessels___ja",
    path: "/ja/vessels",
    component: () => import("/opt/buildhome/repo/pages/vessels.vue")
  },
  {
    name: "vessels___en",
    path: "/en/vessels",
    component: () => import("/opt/buildhome/repo/pages/vessels.vue")
  },
  {
    name: "vessels___zh-cn",
    path: "/zh-cn/vessels",
    component: () => import("/opt/buildhome/repo/pages/vessels.vue")
  },
  {
    name: "agencies___ja___default",
    path: "/agencies",
    component: () => import("/opt/buildhome/repo/pages/agencies.vue"),
    children: [
  {
    name: "agencies-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/agencies/create.vue")
  },
  {
    name: "agencies-orgId___ja___default",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId].vue"),
    children: [
  {
    name: "agencies-orgId-users___ja___default",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "agencies___ja",
    path: "/ja/agencies",
    component: () => import("/opt/buildhome/repo/pages/agencies.vue"),
    children: [
  {
    name: "agencies-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/agencies/create.vue")
  },
  {
    name: "agencies-orgId___ja",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId].vue"),
    children: [
  {
    name: "agencies-orgId-users___ja",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "agencies___en",
    path: "/en/agencies",
    component: () => import("/opt/buildhome/repo/pages/agencies.vue"),
    children: [
  {
    name: "agencies-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/agencies/create.vue")
  },
  {
    name: "agencies-orgId___en",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId].vue"),
    children: [
  {
    name: "agencies-orgId-users___en",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "agencies___zh-cn",
    path: "/zh-cn/agencies",
    component: () => import("/opt/buildhome/repo/pages/agencies.vue"),
    children: [
  {
    name: "agencies-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/agencies/create.vue")
  },
  {
    name: "agencies-orgId___zh-cn",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId].vue"),
    children: [
  {
    name: "agencies-orgId-users___zh-cn",
    path: "users",
    component: () => import("/opt/buildhome/repo/pages/agencies/[orgId]/users.vue")
  }
]
  }
]
  },
  {
    name: "partners___ja___default",
    path: "/partners",
    component: () => import("/opt/buildhome/repo/pages/partners.vue"),
    children: [
  {
    name: "partners-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/partners/create.vue")
  },
  {
    name: "partners-orgId___ja___default",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/partners/[orgId].vue")
  }
]
  },
  {
    name: "partners___ja",
    path: "/ja/partners",
    component: () => import("/opt/buildhome/repo/pages/partners.vue"),
    children: [
  {
    name: "partners-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/partners/create.vue")
  },
  {
    name: "partners-orgId___ja",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/partners/[orgId].vue")
  }
]
  },
  {
    name: "partners___en",
    path: "/en/partners",
    component: () => import("/opt/buildhome/repo/pages/partners.vue"),
    children: [
  {
    name: "partners-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/partners/create.vue")
  },
  {
    name: "partners-orgId___en",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/partners/[orgId].vue")
  }
]
  },
  {
    name: "partners___zh-cn",
    path: "/zh-cn/partners",
    component: () => import("/opt/buildhome/repo/pages/partners.vue"),
    children: [
  {
    name: "partners-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/partners/create.vue")
  },
  {
    name: "partners-orgId___zh-cn",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/partners/[orgId].vue")
  }
]
  },
  {
    name: "admin-login___ja___default",
    path: "/admin/login",
    meta: loginToPgpW8_tXmskc2BbXueNhl3DgZ0QNEnbjd_45I2g34csMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/login.vue")
  },
  {
    name: "admin-login___ja",
    path: "/ja/admin/login",
    meta: loginToPgpW8_tXmskc2BbXueNhl3DgZ0QNEnbjd_45I2g34csMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/login.vue")
  },
  {
    name: "admin-login___en",
    path: "/en/admin/login",
    meta: loginToPgpW8_tXmskc2BbXueNhl3DgZ0QNEnbjd_45I2g34csMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/login.vue")
  },
  {
    name: "admin-login___zh-cn",
    path: "/zh-cn/admin/login",
    meta: loginToPgpW8_tXmskc2BbXueNhl3DgZ0QNEnbjd_45I2g34csMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/login.vue")
  },
  {
    name: "organizations___ja___default",
    path: "/organizations",
    component: () => import("/opt/buildhome/repo/pages/organizations.vue"),
    children: [
  {
    name: "organizations-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/organizations/create.vue")
  },
  {
    name: "organizations-orgId___ja___default",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/organizations/[orgId].vue")
  }
]
  },
  {
    name: "organizations___ja",
    path: "/ja/organizations",
    component: () => import("/opt/buildhome/repo/pages/organizations.vue"),
    children: [
  {
    name: "organizations-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/organizations/create.vue")
  },
  {
    name: "organizations-orgId___ja",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/organizations/[orgId].vue")
  }
]
  },
  {
    name: "organizations___en",
    path: "/en/organizations",
    component: () => import("/opt/buildhome/repo/pages/organizations.vue"),
    children: [
  {
    name: "organizations-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/organizations/create.vue")
  },
  {
    name: "organizations-orgId___en",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/organizations/[orgId].vue")
  }
]
  },
  {
    name: "organizations___zh-cn",
    path: "/zh-cn/organizations",
    component: () => import("/opt/buildhome/repo/pages/organizations.vue"),
    children: [
  {
    name: "organizations-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/organizations/create.vue")
  },
  {
    name: "organizations-orgId___zh-cn",
    path: ":orgId()",
    component: () => import("/opt/buildhome/repo/pages/organizations/[orgId].vue")
  }
]
  },
  {
    name: "quickestimate___ja___default",
    path: "/quickestimate",
    component: () => import("/opt/buildhome/repo/pages/quickestimate.vue")
  },
  {
    name: "quickestimate___ja",
    path: "/ja/quickestimate",
    component: () => import("/opt/buildhome/repo/pages/quickestimate.vue")
  },
  {
    name: "quickestimate___en",
    path: "/en/quickestimate",
    component: () => import("/opt/buildhome/repo/pages/quickestimate.vue")
  },
  {
    name: "quickestimate___zh-cn",
    path: "/zh-cn/quickestimate",
    component: () => import("/opt/buildhome/repo/pages/quickestimate.vue")
  },
  {
    name: "estimator-token___ja___default",
    path: "/estimator-token",
    component: () => import("/opt/buildhome/repo/pages/estimator-token.vue")
  },
  {
    name: "estimator-token___ja",
    path: "/ja/estimator-token",
    component: () => import("/opt/buildhome/repo/pages/estimator-token.vue")
  },
  {
    name: "estimator-token___en",
    path: "/en/estimator-token",
    component: () => import("/opt/buildhome/repo/pages/estimator-token.vue")
  },
  {
    name: "estimator-token___zh-cn",
    path: "/zh-cn/estimator-token",
    component: () => import("/opt/buildhome/repo/pages/estimator-token.vue")
  },
  {
    name: "issued_invoices___ja___default",
    path: "/issued_invoices",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices.vue"),
    children: [
  {
    name: "issued_invoices-invoiceId___ja___default",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "issued_invoices___ja",
    path: "/ja/issued_invoices",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices.vue"),
    children: [
  {
    name: "issued_invoices-invoiceId___ja",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "issued_invoices___en",
    path: "/en/issued_invoices",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices.vue"),
    children: [
  {
    name: "issued_invoices-invoiceId___en",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "issued_invoices___zh-cn",
    path: "/zh-cn/issued_invoices",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices.vue"),
    children: [
  {
    name: "issued_invoices-invoiceId___zh-cn",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/issued_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "approval_requests___ja___default",
    path: "/approval_requests",
    component: () => import("/opt/buildhome/repo/pages/approval_requests.vue"),
    children: [
  {
    name: "approval_requests-id___ja___default",
    path: ":id()",
    component: () => import("/opt/buildhome/repo/pages/approval_requests/[id].vue")
  }
]
  },
  {
    name: "approval_requests___ja",
    path: "/ja/approval_requests",
    component: () => import("/opt/buildhome/repo/pages/approval_requests.vue"),
    children: [
  {
    name: "approval_requests-id___ja",
    path: ":id()",
    component: () => import("/opt/buildhome/repo/pages/approval_requests/[id].vue")
  }
]
  },
  {
    name: "approval_requests___en",
    path: "/en/approval_requests",
    component: () => import("/opt/buildhome/repo/pages/approval_requests.vue"),
    children: [
  {
    name: "approval_requests-id___en",
    path: ":id()",
    component: () => import("/opt/buildhome/repo/pages/approval_requests/[id].vue")
  }
]
  },
  {
    name: "approval_requests___zh-cn",
    path: "/zh-cn/approval_requests",
    component: () => import("/opt/buildhome/repo/pages/approval_requests.vue"),
    children: [
  {
    name: "approval_requests-id___zh-cn",
    path: ":id()",
    component: () => import("/opt/buildhome/repo/pages/approval_requests/[id].vue")
  }
]
  },
  {
    name: "approved_invoices___ja___default",
    path: "/approved_invoices",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices.vue"),
    children: [
  {
    name: "approved_invoices-invoiceId___ja___default",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "approved_invoices___ja",
    path: "/ja/approved_invoices",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices.vue"),
    children: [
  {
    name: "approved_invoices-invoiceId___ja",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "approved_invoices___en",
    path: "/en/approved_invoices",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices.vue"),
    children: [
  {
    name: "approved_invoices-invoiceId___en",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "approved_invoices___zh-cn",
    path: "/zh-cn/approved_invoices",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices.vue"),
    children: [
  {
    name: "approved_invoices-invoiceId___zh-cn",
    path: ":invoiceId()",
    component: () => import("/opt/buildhome/repo/pages/approved_invoices/[invoiceId].vue")
  }
]
  },
  {
    name: "bonded_warehouses___ja___default",
    path: "/bonded_warehouses",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses.vue"),
    children: [
  {
    name: "bonded_warehouses-create___ja___default",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/create.vue")
  },
  {
    name: "bonded_warehouses-bondedWarehouseId___ja___default",
    path: ":bondedWarehouseId()",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/[bondedWarehouseId].vue")
  }
]
  },
  {
    name: "bonded_warehouses___ja",
    path: "/ja/bonded_warehouses",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses.vue"),
    children: [
  {
    name: "bonded_warehouses-create___ja",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/create.vue")
  },
  {
    name: "bonded_warehouses-bondedWarehouseId___ja",
    path: ":bondedWarehouseId()",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/[bondedWarehouseId].vue")
  }
]
  },
  {
    name: "bonded_warehouses___en",
    path: "/en/bonded_warehouses",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses.vue"),
    children: [
  {
    name: "bonded_warehouses-create___en",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/create.vue")
  },
  {
    name: "bonded_warehouses-bondedWarehouseId___en",
    path: ":bondedWarehouseId()",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/[bondedWarehouseId].vue")
  }
]
  },
  {
    name: "bonded_warehouses___zh-cn",
    path: "/zh-cn/bonded_warehouses",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses.vue"),
    children: [
  {
    name: "bonded_warehouses-create___zh-cn",
    path: "create",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/create.vue")
  },
  {
    name: "bonded_warehouses-bondedWarehouseId___zh-cn",
    path: ":bondedWarehouseId()",
    component: () => import("/opt/buildhome/repo/pages/bonded_warehouses/[bondedWarehouseId].vue")
  }
]
  },
  {
    name: "billing_and_payments___ja___default",
    path: "/billing_and_payments",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments.vue"),
    children: [
  {
    name: "billing_and_payments-orderId___ja___default",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments/[orderId].vue")
  }
]
  },
  {
    name: "billing_and_payments___ja",
    path: "/ja/billing_and_payments",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments.vue"),
    children: [
  {
    name: "billing_and_payments-orderId___ja",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments/[orderId].vue")
  }
]
  },
  {
    name: "billing_and_payments___en",
    path: "/en/billing_and_payments",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments.vue"),
    children: [
  {
    name: "billing_and_payments-orderId___en",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments/[orderId].vue")
  }
]
  },
  {
    name: "billing_and_payments___zh-cn",
    path: "/zh-cn/billing_and_payments",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments.vue"),
    children: [
  {
    name: "billing_and_payments-orderId___zh-cn",
    path: ":orderId()",
    component: () => import("/opt/buildhome/repo/pages/billing_and_payments/[orderId].vue")
  }
]
  },
  {
    name: "procurement_expenses-import___ja___default",
    path: "/procurement_expenses/import",
    component: () => import("/opt/buildhome/repo/pages/procurement_expenses/import.vue")
  },
  {
    name: "procurement_expenses-import___ja",
    path: "/ja/procurement_expenses/import",
    component: () => import("/opt/buildhome/repo/pages/procurement_expenses/import.vue")
  },
  {
    name: "procurement_expenses-import___en",
    path: "/en/procurement_expenses/import",
    component: () => import("/opt/buildhome/repo/pages/procurement_expenses/import.vue")
  },
  {
    name: "procurement_expenses-import___zh-cn",
    path: "/zh-cn/procurement_expenses/import",
    component: () => import("/opt/buildhome/repo/pages/procurement_expenses/import.vue")
  }
]